//Library Imports
import React from "react";
import { FC } from "react";
import { Link, useHistory } from "react-router-dom";
import { useTable, useSortBy } from "react-table";
import styled from "styled-components";

//Local Imports
import DownAngle from "../../../assets/img/icons/DownAngle.svg";
import InfiniteLoader from "./InfiniteLoader";
import useQuery from "hooks/useQuery";

interface TableProps {
  columns: any[];
  data: any;
  module: string;
  _onCellClick?: (columnProps: any) => void;
  _onRowClick?: (event: any, rowProps: any, history: any) => void;
  loader?: any;
  next?: any;
  hasMore?: boolean;
  loading?: boolean;
  wrapperClassName?: string;
  noScrollTarget?: boolean;
  useCustomQuery?: boolean;
}
const Table: FC<TableProps> = (props: TableProps) => {
  const {
    columns,
    data,
    _onCellClick,
    _onRowClick,
    loader,
    next,
    loading,
    wrapperClassName,
    hasMore,
    noScrollTarget,
    useCustomQuery
  } = props;
  const tableInstance = useTable({ columns, data, manualSortBy: true }, useSortBy);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;
  const history = useHistory();
  const query = useQuery();
  const url = "&" + query.toString();

  const rowDiv = (row: any, i: any) => (
    <tr
      {...row.getRowProps()}
      onClick={(e) => (_onRowClick ? _onRowClick(e, row.original, history) : null)}
      key={i}
    >
      {row.cells.map((cell) => {
        return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
      })}
    </tr>)

  return (
    <Wrapper
      {...(wrapperClassName ? { className: wrapperClassName } : {})}
      noData={data?.length === 0 && !loading}
    >
      <table {...getTableProps()} style={{ width: "100%" }}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  onClick={() => _onCellClick && _onCellClick(column)}
                  title=""
                >
                  {!column.hideHeader && column.render("Header")}
                  {/* Add a sort direction indicator */}
                  {column.sortDirection === "ASC" ? (
                    <span>
                      <span className="sort_asc">
                        <img src={DownAngle} alt="Sort Asc" />
                      </span>
                    </span>
                  ) : column.sortDirection === "DESC" ? (
                    <span>
                      <span className="sort_desc">
                        <img src={DownAngle} alt="Sort Desc" />
                      </span>
                    </span>
                  ) : !column.disableSortBy ? (
                    <span>
                      <span className="sort_asc">
                        <img src={DownAngle} alt="Sort Asc" />
                      </span>
                      <span className="sort_desc">
                        <img src={DownAngle} alt="Sort Desc" />
                      </span>
                    </span>
                  ) : null}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody id="scrollableDiv" {...getTableBodyProps()}>
          {/* 
              adding infinite loader inside table body so that we can manage to contain 
              the table inside a div/container and keep the header sticky all the time
          */}
          {loading && data?.length === 0 ? (
            loader
          ) : (
            <InfiniteLoader
              next={next}
              dataLength={data?.length}
              hasMore={hasMore ?? true}
              loader={loader}
              {...(noScrollTarget ? {} : { scrollableTarget: "scrollableDiv" })}
            >
              {rows.map((row, i) => {
                prepareRow(row);
                return (
                  useCustomQuery ?
                    <Link to={row.original?.queryParam + url}>
                      {rowDiv(row, i)}
                    </Link> :
                    rowDiv(row, i)
                );
              })}
            </InfiniteLoader>
          )}
        </tbody>
      </table>
    </Wrapper>
  );
};

export default Table;

const Wrapper = styled.div<any>`
  margin-bottom: 0px;
  position: relative;
  box-sizing: border-box;
  ${(props) => (props.noData ? `tbody { height: auto !important; }` : `height: calc(100vh - 330px);`)}
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    height: calc(100vh - 280px);
  }
  scrollbar-width: thin;
  scrollbar-color: #001760 #efefef;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    border-radius: 5px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: #fff;
    margin-top: 50px;
    margin-bottom: 90px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-top: 40px;
    }
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #001760;
  }
  /* Handle on hover */
  /* &::-webkit-scrollbar-thumb:hover {
    background: #efefef;
  } */
  &.sortable {
    min-height: 530px;
  }
  > div {
    overflow: hidden;
  }
  #scrollableDiv {
    .infinite-scroll-component {
      position: relative;
      min-height:calc(100vh - 340px);
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        min-height:calc(100vh - 300px);
      }
    }
  }
`;
